var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 60,
    viewBox: "0 0 68 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 29.995L34 0.5L17 29.995L0 59.5H68L51 30.005V29.995ZM35.42 23.3326L35.24 42.5484H32.76L32.56 23.3326H35.42ZM35.72 49.4513C35.55 49.7518 35.3 49.9923 34.99 50.1726C34.68 50.3529 34.35 50.4531 34 50.4531C33.65 50.4531 33.31 50.363 33 50.1726C32.69 49.9923 32.45 49.7518 32.27 49.4513C32.09 49.1507 32.01 48.8201 32.01 48.4694C32.01 48.1088 32.09 47.7781 32.27 47.4676C32.45 47.157 32.69 46.9165 33 46.7462C33.31 46.5759 33.64 46.4857 34 46.4857C34.36 46.4857 34.68 46.5759 34.99 46.7462C35.3 46.9165 35.54 47.157 35.72 47.4676C35.9 47.7781 35.98 48.1188 35.98 48.4694C35.98 48.8201 35.89 49.1607 35.72 49.4513Z",
    fill: "#D3D6D9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotFound);
export default __webpack_public_path__ + "static/media/ic_not_found.5162cb8a75605f8469f51337b14b82ef.svg";
export { ForwardRef as ReactComponent };